import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Reveal from "@/components/site/Reveal";
import { api, API } from "@/lib/api";

const CAT_LABEL = { before: "Before", after: "After", showcase: "Project" };

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 lg:py-32 bg-ink">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl mb-14">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Our Work</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-heading font-bold tracking-tight text-white text-4xl sm:text-6xl leading-[1]">
              Recent Projects
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-white/70 max-w-xl">
              A look at real work completed for homeowners across the greater San Antonio area.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <motion.div
              key={it.id}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden border border-line ${i % 5 === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
            >
              <img
                src={`${API}/gallery/${it.id}/image`}
                alt={it.title || "B3 Contracting project"}
                className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 p-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <span className="text-[10px] uppercase tracking-widest text-gold">{CAT_LABEL[it.category] || "Project"}</span>
                {it.title && <p className="text-white font-heading text-sm">{it.title}</p>}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
